export default "__VITE_ASSET__8b0044ec__"